import { ProgressSteps } from "../progressSteps/ProgressSteps";
import { QuickNavigation } from "../quickNavigation/QuickNavigation";

import type { QuickNavigationItem } from "../quickNavigation/QuickNavigation";

export interface QuizViewMenuProps {
  currentItemId?: string;
  currentStep?: number;
  items?: QuickNavigationItem[];
  label: string;
  preLabel?: string;
  stepCount?: number;
}

export function QuizViewMenu({
  currentItemId,
  currentStep,
  items,
  label,
  preLabel,
  stepCount,
}: QuizViewMenuProps) {
  const shouldRenderProgress = stepCount != null;

  return (
    <div className="QuizViewMenu">
      <QuickNavigation
        currentItemId={currentItemId}
        preLabel={preLabel}
        label={label}
        items={items}
      />

      {shouldRenderProgress && (
        <ProgressSteps stepCount={stepCount} currentStep={currentStep} />
      )}
    </div>
  );
}
